import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import { usePreferences } from '../usePreferences';

export interface VoiceNoteTemplateSection {
  id: string;
  order: number;
  key: string;
  label: string;
  description: string;
}

export interface VoiceNoteTemplateCreator {
  type: 'organization' | 'practice';
  id: string;
  name: string;
}

export interface VoiceNoteTemplate {
  id: string;
  name: string;
  type: string;
  namespace: string;
  createdBy: VoiceNoteTemplateCreator | null;
  sections: VoiceNoteTemplateSection[];
}

export const useVoiceNoteTemplates = (namespace?: string) => {
  // templates are gated by a feature flag
  const { data: preferences } = usePreferences();
  const isVideaNotesEnabled = preferences?.isVideaNotesEnabled;
  const enableVoiceNotesCustomTemplates =
    preferences?.enableVoiceNotesCustomTemplates;

  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'voice-note-templates',
      currentPracticeId,
      currentOrganizationId,
      namespace,
    ],
    queryFn: async () => {
      return makeAPIRequestReactQuery<VoiceNoteTemplate[]>(
        '/voice-note-templates',
        namespace ? { namespace } : {},
        'get',
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
    enabled:
      currentPracticeId !== undefined &&
      currentOrganizationId !== undefined &&
      isVideaNotesEnabled === true &&
      enableVoiceNotesCustomTemplates === true,
  });
};
